import { get, set } from 'dot-prop'
import clone from '@fno/lib/clone'
import transformApiResponseToFormObject from '@fno/lib/transform-api-response-to-form-object'

export default ({ page, responses, context }) => {
    const alerts = []
    const updatedForm = clone(context.form)

    const mutate = (formKey, index) => {
        const keypath = `${formKey}${index === undefined ? '' : `.${index}`}`
        const { success, error } = get(responses, keypath) || {}
        if (success) {
            set(updatedForm, keypath, transformApiResponseToFormObject({
                schema: page[formKey].schema,
                data: success
            }))
        } else if (error && error.errors) {
            alerts.push(...error.errors.map(e => ({
                formKey,
                index,
                level: 'error',
                error: e
            })))
        } else if (error) {
            alerts.push({
                formKey,
                index,
                level: 'error',
                error
            })
        }
    }

    Object.keys(page).forEach(formKey => {
        if (responses[formKey] && page[formKey].type === Array) {
            Object.keys(responses[formKey]).forEach(index => {
                mutate(formKey, index)
            })
        } else if (responses[formKey]) {
            mutate(formKey)
        }
    })

    return { alerts, updatedForm }
}
